import { AppState, ERROR_SCREEN_TYPES } from 'config/config';
import React, { useEffect } from 'react';

import { IAppState } from 'types/ApplicationState';
import ErrorView from './errorView/ErrorView';
import TokenExpiredScreen from './tokenExpiredScreen/TokenExpiredScreen';
import NotPermittedScreen from './notPermittedScreen/NotPermittedScreen';
import withAppStateContext from '../../hoc/withAppStateContext';

export interface IErrorProps extends Partial<IContext>, Partial<ITextContext>, Partial<IAppState> {
  name?: string;
  message?: string;
  stack?: string | undefined;
  screenType?: string;
}

function ErrorViewSelector({ screenType, setAppState }: IErrorProps) {
  useEffect(() => {
    setAppState?.(AppState.ERROR);
  }, []);

  switch (screenType) {
    case ERROR_SCREEN_TYPES.PAYMENT_TOKEN_EXPIRED:
      return <TokenExpiredScreen />;
    case ERROR_SCREEN_TYPES.NOT_PERMITTED:
      return <NotPermittedScreen />;
    default:
      return <ErrorView screenType={screenType} />;
  }
}
export default withAppStateContext(ErrorViewSelector);
